<template>
  <el-dialog
    v-model="dialogVisible"
    title="告警详情"
    width="900px"
    @close="closeDialog"
  >
    <div v-if="itemInfo" class="alarmDetailDialog">
      <el-card class="tree-card" :body-style="treeCard">
        <img :src="itemInfo.pictureUrl" v-if="itemInfo" />
      </el-card>
      <el-card class="tabs-card">
        <div class="tabsCard-content-left" v-if="itemInfo">
          <div class="Title">告警信息</div>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >告警等级:&nbsp;&nbsp;{{ itemInfo.alarmLevel }}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >告警类型:&nbsp;&nbsp;{{ itemInfo.alarmTypeName }}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >告警时间:&nbsp;&nbsp;{{ itemInfo.alarmTime }}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >告警源类型:&nbsp;&nbsp;{{ itemInfo.alarmSourceName }}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >告警设备:&nbsp;&nbsp;{{ itemInfo.deviceName }}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >告警标题:&nbsp;&nbsp;{{ itemInfo.alarmName }}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >告警地点:&nbsp;&nbsp;{{ itemInfo.deviceName }}</el-col
            >
          </el-row>

          <!-- <div class="Title">车辆信息</div>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >车牌号码:&nbsp;&nbsp;{{ itemInfo.biz1 }}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >车辆类型:&nbsp;&nbsp;{{}}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >车身颜色:&nbsp;&nbsp;{{}}</el-col
            >
          </el-row>
          <el-row>
            <el-col class="leftTitle" :span="24"
              >车牌颜色:&nbsp;&nbsp;{{}}</el-col
            >
          </el-row> -->
        </div>
      </el-card>
      <div class="notHandleImg" v-show="itemInfo.alarmStatus == 0"></div>
      <div class="handleImg" v-show="itemInfo.alarmStatus == 1"></div>
    </div>
    <!-- <template #footer>
      <span class="dialog-footer">
        <h-button type="primary" @click="emitCheckList">处理</h-button>
        <h-button @click="closeDialog">关闭</h-button>
      </span>
    </template> -->
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  watchEffect,
  onMounted,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import util from "@util/js";
export default defineComponent({
  name: "alarmDetailDialog",
  components: { MyMap },
  props: {
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      loading: false,
      tableData: null,
      dialogVisible: false,
      treeCard: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      showDeckFirst: false,
      showDeckSecond: false,
      currentRow: null,
      dataInfo: null,
    });
    const tableRef = ref(null);
    const refData = toRefs(data);
    const mapRef = ref();
    // 使用wache监听不报红
    watchEffect(() => {
      data.dialogVisible = props.visible;
    });
    const closeDialog = () => {
      emit("update:visible", false);
    };
    console.log(props.itemInfo);
    return {
      ...refData,
      mapRef,
      tableRef,
      closeDialog,
    };
  },
});
</script>
<style lang="scss" scoped>
.alarmDetailDialog {
  width: 100%;
  height: 40vh;
  display: flex;
  position: relative;
  .Title {
    border-left: 3px solid #5584ff;
    font-size: 14px;
    color: #333;
    font-weight: bolder;
    height: 20px;
    line-height: 20px;
    padding-left: 8px;
    margin: 15px 0;
  }

  .tree-card {
    height: 100%;
    width: 300px;
    @include flex-col-c-c;
    img {
      width: 90%;
      height: 50%;
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    /deep/ .el-card__body {
      flex-direction: row !important;
    }

    .el-row {
      margin: 8px 0 16px 16px;
    }
    .tabsCard-content-left {
      width: 100%;
      height: 100%;
    }
  }
  .handleImg {
    width: 85px;
    height: 85px;
    position: absolute;
    right: 27px;
    top: 0;
    top: 0;
    background: url("~@/assets/images/weichuli.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
